export const TRANSACTION_ORDER = 'vivienda/order/TRANSACTION_ORDER'

export function fetchTransaction(data) {
    return {
        type: TRANSACTION_ORDER,
        payload: data
    }
}